/* global wp */
/* eslint-disable */

/**
 * Remove the drop cap option from the core paragraph block.
 * This is a really strange way to do this but essentially we are just adding an empty element with a custom, unique selector.
 * This selector is then used in CSS to target the sibling panel and hide the drop cap option.
 *
 * Amazingly this appears to be the easiest (and potentially only way) of doing this...
 * Which frankly is very poor from Automattic...
 */
(() => {
  const { createHigherOrderComponent } = wp.compose;
  const { Fragment } = wp.element;
  const { InspectorControls } = wp.blockEditor;
  const { PanelBody } = wp.components;

  const withInspectorControls = createHigherOrderComponent(BlockEdit => {
    return props => {
      if (props.name !== 'core/paragraph') {
        return <BlockEdit {...props} />;
      }

      // Pop a custom div in the inspector controls so we can use it to target the dropcap component... smh...
      return (
        <Fragment>
          <InspectorControls>
            <div className="core-paragraph-inspector"></div>
          </InspectorControls>
          <BlockEdit {...props} />
        </Fragment>
      );
    };
  }, 'withInspectorControl');
  wp.hooks.addFilter('editor.BlockEdit', 'cjbs/utilities', withInspectorControls);
})();

/**
 * Force all postboxes (expanding meta field groups below the editor) to close on page load.
 */
(() => {
  document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('.postbox').forEach(postbox => {
      postbox.classList.add('closed');
    });
  });
})();
